import { useEffect } from "react";
import { Outlet, useLocation } from "react-router";
import { noteLocation } from "./update.js";

/**
 * Корневой маршрут без пути: общий `errorElement` и слежение за переходами для обновления после выкладки.
 * `noteLocation` зовётся из эффекта по `pathname`: старая страница к этому моменту размонтирована (её `beforeunload`
 * снят, диалог «Покинуть сайт?» не удвоится), а смена только параметров адреса (`?q=`, `?day=`, `?booking=`)
 * переходом не считается и работу не прерывает.
 */
export function Root() {
  const { pathname } = useLocation();
  useEffect(() => {
    noteLocation(pathname);
  }, [pathname]);
  return <Outlet />;
}
